/**
 * Constants and types for rollout dialog functionality
 */

/**
 * Month configuration for rollout dialog dropdowns
 * Uses numeric values (0-11) to match JavaScript Date.getMonth()
 */
export const ROLLOUT_MONTHS = [
  { value: 0, key: 'january' },
  { value: 1, key: 'february' },
  { value: 2, key: 'march' },
  { value: 3, key: 'april' },
  { value: 4, key: 'may' },
  { value: 5, key: 'june' },
  { value: 6, key: 'july' },
  { value: 7, key: 'august' },
  { value: 8, key: 'september' },
  { value: 9, key: 'october' },
  { value: 10, key: 'november' },
  { value: 11, key: 'december' },
] as const;

/**
 * Type for rollout month configuration
 */
export type RolloutMonth = (typeof ROLLOUT_MONTHS)[number];

/**
 * Status types for rollout operations
 */
export enum RolloutStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  BACKGROUND = 'background', // Running in Service Worker
  SUCCESS = 'success',
  WARNING = 'warning', // Partial success - some successful, some failed
  ERROR = 'error',
}

export const afterDateForLogs = '2025-08-01T14:28:29.885Z';
